"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var base = /*#__PURE__*/(0, _react.css)("height:", (0, _util.rem)(32), ";transition:height 0.1s ease-out;display:inline-block;" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
var hidden = process.env.NODE_ENV === "production" ? {
  name: "1c4sepd",
  styles: "height:0;overflow:hidden;margin-bottom:0!important;button{opacity:0;transition:none;}"
} : {
  name: "cc88pi-hidden",
  styles: "height:0;overflow:hidden;margin-bottom:0!important;button{opacity:0;transition:none;};label:hidden;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var styles = {
  base: base,
  hidden: hidden
};
exports.styles = styles;
//# sourceMappingURL=RemoveSortBtn.styles.js.map